import React from 'react';
import {Link} from 'react-router-dom';
import {AurSelect} from '../../../common/aur-select/AurSelect';

const Select: React.FC = () => {
  const optionList = [
    'System Administrator',
    'Client Adminstrator',
    'Consilio User',
    'Client User',
  ];

  const clickChangeHandler = () => {
    alert('Change detected');
  };

  const clickBlurHandler = () => {
    //alert('Blur detected');
  };

  const myField = {
    value: '',
    onChange: () => clickChangeHandler(),
    onBlur: () => clickBlurHandler(),
  };

  const myFieldState = {
    error: {
      message: 'Error message',
    },
  };

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Select</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurSelect
            label="User Roles"
            optionList={optionList}
            field={myField}
            fieldState={myFieldState}
          />
        </div>
      </div>
    </>
  );
};

export default Select;
